// Activity-first listing policy helpers.
// Business hosts are listed for the activities they run — they never appear
// in the public organisations directory and can't be followed or post updates.

export const BUSINESS_HOST_CATEGORIES = ["activity hosts", "local businesses", "local business"];

export const isBusinessHost = (org) =>
    org?.org_type === "business_host" ||
    BUSINESS_HOST_CATEGORIES.includes(String(org?.category || "").trim().toLowerCase());

export const isDirectoryListed = (org) => org?.status !== "pending" && !isBusinessHost(org);

export const hostHasUpcomingActivity = (org, events) =>
    (events || []).some(
        (e) =>
            e.orgSlug === org?.slug &&
            e.status === "approved" &&
            e.start &&
            new Date(e.start) >= new Date(),
    );
